import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

export default function InputMultipleLines(props) {
  return (
    <Box component="form" noValidate autoComplete="off">
      <TextField
        id="standard-multiline-static"
        label={props.label}
        fullWidth
        multiline={props.multiline}
        rows={props.rows}
        defaultValue={props.value}
        variant="standard"
        InputLabelProps={{
          shrink: true,
        }}
        onChange={props.onChange}
        sx={{
          '& .MuiInputLabel-root': {
            color: 'rgba(70, 70, 70, 0.6)',
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: 'Roboto',
            fontSize: '1rem',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '1.4375em',
            letterSpacing: '0.15px',
            margin: '0.32rem 0',
          },
        }}
      />
    </Box>
  );
}
